import { render, staticRenderFns } from "./ContentLoader.vue?vue&type=template&id=fc886b3e"
import script from "./ContentLoader.vue?vue&type=script&lang=js"
export * from "./ContentLoader.vue?vue&type=script&lang=js"
import style0 from "./ContentLoader.vue?vue&type=style&index=0&id=fc886b3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports